import { render, staticRenderFns } from "./MaterialControls.vue?vue&type=template&id=0ac27b9c&scoped=true&"
import script from "./MaterialControls.vue?vue&type=script&lang=js&"
export * from "./MaterialControls.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/material_controls.css?vue&type=style&index=0&id=0ac27b9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac27b9c",
  null
  
)

export default component.exports